<template>
  <form class="calendar_tab calendar-tab-pc">
    <div class="calendar-result ">
      <div class="panel panel-default">
        <calendar-header :nameCodapp="labels[nowLang].nameCodapp" :linkToRedirect="linkToRedirect" :tooltip="header_tooltip" :linkDisp="false" />
            <filter-date :showTabDate="showTabDate"/>
            <div class="body-pc">
          <template v-for="value in filterCalendarTab({ tab: 'tab3', calendarTabRows: calendarTab3.rows })">
            <div class="panel-body remove-border">
              <div class="row">
                  <div class="col-xs-12 font-bold set-topic-tab3">
                    <i class="fa fa-lightbulb-o color-skin" aria-hidden="true"></i> <label class="text_use color-skin" >{{ value.title }}</label>
                  </div>
                  <div class="col-xs-12 set-font-tab3">
                    <i class="fa fa-clock-o i3" aria-hidden="true"></i> <label class="text_time1" >{{ timeRange(value.timestr, value.timeend) }}</label>
                  </div>
                  <div class="col-xs-12 set-font-tab3">
                    <i class="fa fa-map-marker i2" aria-hidden="true"></i> <label class="text_time1">{{ value.place }}</label>
                  </div>
              </div>
            </div>
            <hr>
          </template>
        </div>
      </div>
    </div>
  </form>
</template>

<script>
import calendarHeader from 'components/calendar/calendar_header'
import filterDate from 'components/calendar/filter_date'

export default {
  name: 'calendar_tab3',
  props: [ 'calendarTab3', 'filterCalendarTab', 'nowLang' ],
  data () {
    return {
      linkToRedirect: 'hres42x',
      header_tooltip: 'Link to Training page',
      labels: {
        en: {
          nameCodapp: 'Training'
        },
        th: {
          nameCodapp: 'วันฝึกอบรม'
        }
      }
    }
  },
  methods: {
    timeFormat (time) {
      let timeReplaced = time.replace(':', '')
      return timeReplaced.substr(0, 2) + ':' + timeReplaced.substr(2, 2)
    },
    timeRange (timestr, timeend) {
      if (timestr !== '' || timeend !== '') {
        return this.timeFormat(timestr) + ' - ' + this.timeFormat(timeend)
      }
      return ''
    }
  },
  components: {
    calendarHeader,
    filterDate
  }
}
</script>





// WEBPACK FOOTER //
// calendar_tab3.vue?5a818190